/**
 * Returns true at approximately the given sample rate.
 */
const sampleRate = (rate: number): boolean => {
    if (rate <= 0) return false;
    if (rate >= 1) return true;

    return Math.random() < rate;
};

export default sampleRate;
